import barba from '@barba/core';
import barbaCss from '@barba/css';
import barbaPrefetch from '@barba/prefetch';
import barbaRouter from '@barba/router';
import gsap from 'gsap';

document.addEventListener('DOMContentLoaded', () => {
  let $ = jQuery;
  let resizeTimer;
  const myRoutes = [{
    path: '/',
    name: 'home',
  }, {
    path: '/resume',
    name: 'resume',
  }, {
    path: '/videos',
    name: 'videos',
  }, {
    path: '/photos',
    name: 'photos',
  }, {
    path: '/reel',
    name: 'reel',
  }, {
    path: '/who-me',
    name: 'who-me',
  }, {
    path: '/pay-it-forward',
    name: 'pay-it-forward',
  }, {
    path: '/contact',
    name: 'contact',
  }];

  const body = document.querySelector('body');
  barba.use(barbaCss);
  /*barba.use(barbaPrefetch);
  barba.use(barbaRouter, {
    routes: myRoutes,
  });*/
  let shouldReload = false;
  const initPageTransitions = () => {
    barba.hooks.beforeOnce(({ next }) => {
      next.container.classList.add('transparent');
      body.className = next.namespace;
    });

    barba.hooks.afterOnce(({ next }) => {
      next.container.classList.remove('transparent');
    });

    barba.hooks.before(({ next }) => {
      next.container.classList.add('transparent');
      body.className = next.namespace;
    });

    barba.hooks.beforeLeave(() => {
      body.classList.add('overflow-hidden');
    });

    barba.hooks.afterEnter(({ next }) => {
      body.classList.remove('overflow-hidden');
      next.container.classList.remove('transparent');
      if (next.namespace === 'contact') {
        shouldReload && location.reload();
        shouldReload = false;
      } else {
        shouldReload = true;
      }
    });

    barba.init({
      debug: true,
      //timeout: 5000,
      views: [{
        namespace: 'home',
        afterEnter() {
          initNewsSlider();
          movePhotoOnMousemove();
        },
      }, {
        namespace: 'videos',
        afterEnter() {
          setVideoDimensions();
          //videoLinkClickHandler();
          //closeButtonClickHandler();
        },
      }/*, {
      namespace: 'who-me',
      afterEnter() {
        aboutListItemMouseEventHandler();
      },
    }*/],
      transitions: [{
        name: 'clip',
        to: {
          namespace: ['resume', 'contact'],
        },
        sync: true,
        leave() { },
        enter() { },
      }, {
        name: 'default',
        sync: true,
        once() { },
        leave() { },
        beforeEnter({ next }) {
          gsap.set(next.container, { autoAlpha: 1 });
        },
        enter() { },
      }],
    });
  };

  const initOrDestroyPageTransitions = () => {
    if (window.innerWidth >= 768 && !barba.views) {
      initPageTransitions();
    } else if (window.innerHeight < 768 && barba.views) {
      barba.destroy();
    }
  };

  const highlightBrandText = () => {
    setTimeout(() => {
      gsap.timeline()
        .to('.brand > span', {
          duration: 0.5,
          color: '#e3d1d0',
          stagger: 0.1,
          ease: 'power2.out',
        })
        .to('.brand > span', {
          duration: 0.5,
          color: '#fff',
          stagger: 0.1,
          ease: 'power2.out',
        }, 0.5);
    }, 500);
  };

  const unwrapDropdownMenu = () => {
    const $dropdown = $('.navbar-nav .dropdown');
    const numDropdowns = $dropdown.length;
    const $dropdownItem = $('.dropdown-toggle').siblings('.dropdown-item');
    if (numDropdowns) {
      $('.navbar-nav').data('numDropdowns', $dropdown.length);
    }

    if ($('.navbar-nav > li').css('float') === 'left') {
      $dropdown.each(function (index) {
        $(this).find('.dropdown-toggle, li')
          .addClass('dropdown-item dropdown-' + (index + 1) + '-item')
          .unwrap();
      });
    } else if ($dropdownItem.length) {
      for (let i = 1; i <= $('.navbar-nav').data('numDropdowns'); i++) {
        $('li.dropdown-' + i + '-item').wrapAll('<ul class="dropdown-menu dropdown-menu-' + i + '"></ul>');
        $('.dropdown-toggle.dropdown-' + i + '-item, .dropdown-menu-' + i).wrapAll('<li class="dropdown"></li>')
      }
    }
  };

  const moveDownloadBtn = () => {
    const $downloadBtn = $('.btn--download-press-kit');
    if ($('.navbar-nav > li').css('float') === 'left') {
      $downloadBtn.appendTo('.navbar-nav');
    } else {
      $downloadBtn.insertBefore('.navbar-default');
    }
  };

  const initNewsSlider = () => {
    const $newsSlider = $('.c-news__slider');
    if ($newsSlider.length > 0 && typeof $newsSlider.flexslider === 'function' && !$newsSlider.hasClass('flexslider')) {
      $newsSlider.flexslider({
        directionNav: false,
      });
    }
  };

  const movePhotoOnMousemove = () => {
    const container = document.querySelector('.container-home');
    if (!container) {
      return;
    }

    container.addEventListener('mousemove', ({ offsetX, offsetY, target }) => {
      const { clientWidth, clientHeight } = target;
      const xPos = offsetX / clientWidth - 0.5;
      const yPos = offsetY / clientHeight - 0.5;
      gsap.to('.headshot__img', {
        duration: 1.2,
        x: xPos * 10,
        y: yPos * 7,
        rotationY: xPos * 10,
        rotationX: yPos * 7,
      });
    })
  };

  const calculateVideoDimensions = () => {
    const videoAspectRatio = 1.7778;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    let videoWidth;
    let videoHeight;
    const videoMaxWidth = 1280;
    const videoMaxHeight = 720;
    const videoMaxWidth111p = videoMaxWidth / 0.9;
    const videoMaxHeight111p = videoMaxHeight / 0.9;
    const windowAspectRatio = windowWidth / windowHeight;
    if (windowAspectRatio > videoAspectRatio) {
      if (windowHeight > videoMaxHeight111p) {
        videoHeight = videoMaxHeight;
        videoWidth = videoMaxWidth;
      } else {
        videoHeight = windowHeight * 0.9;
        videoWidth = videoHeight * videoAspectRatio;
      }
    } else {
      if (windowWidth > videoMaxWidth111p) {
        videoWidth = videoMaxWidth;
        videoHeight = videoMaxHeight;
      } else {
        videoWidth = windowWidth * 0.9;
        videoHeight = videoWidth / videoAspectRatio;
      }
    }

    return {
      width: videoWidth,
      height: videoHeight,
    };
  };

  const setVideoDimensions = () => {
    const videoDimensions = calculateVideoDimensions();
    $('.c-video').each(function () {
      this.width = videoDimensions.width;
      this.height = videoDimensions.height;
    });
  };

  const videoLinkClickHandler = () => {
    $('body').on('click', '.js-open-video', function (e) {
      e.preventDefault();
      const id = $(this).attr('href');
      const $video = $(id);
      $('.c-overlay').fadeIn();
      $video.fadeIn();
      $video[0].src += /\?[^?]+/.test($video[0].src) ? '&autoplay=1' : '?autoplay=1';
      $('.c-close-button').fadeIn();
      $('.js-close-video').data('videoId', id);
    });
  };

  const closeButtonClickHandler = () => {
    $('body').on('click', '.js-close-video', function (e) {
      const $currentVideo = $($(this).data('videoId'));
      const videoSrc = $currentVideo.attr('src').split(/\?autoplay=1|&autoplay=1/)[0];
      $currentVideo.attr('src', '')
        .attr('src', videoSrc)
        .fadeOut();
      $('.c-close-button, .c-overlay').fadeOut();
    });
  };

  const aboutListItemMouseEventHandler = () => {
    $('body')
      .on('mouseenter', '.c-about-section__list-item', function () {
        $($(this).data('bg')).addClass('is-active');
      })
      .on('mouseleave', '.c-about-section__list-item', function () {
        $($(this).data('bg')).removeClass('is-active');
      })
      .on('focusin', '.c-about-section__list-item', function () {
        if ($(this).is(':focus-visible')) {
          $($(this).data('bg')).addClass('is-active');
        }
      })
      .on('focusout', '.c-about-section__list-item', function () {
        if ($(this).is(':focus-visible')) {
          $($(this).data('bg')).removeClass('is-active');
        }
      });
  };

  const moveLabels = () => {
    $('body').on('focus', '.c-contact-form__input, .c-contact-form__textarea', function () {
      this.closest('.form-group').classList.add('has-text');
    })
      .on('blur', '.c-contact-form__input, .c-contact-form__textarea', function() {
        this.value || this.closest('.form-group').classList.remove('has-text');
      });
  };

  initOrDestroyPageTransitions();
  unwrapDropdownMenu();
  moveDownloadBtn();
  initNewsSlider();
  movePhotoOnMousemove();
  setVideoDimensions();
  videoLinkClickHandler();
  closeButtonClickHandler();
  aboutListItemMouseEventHandler();
  moveLabels();

  window.addEventListener('load', () => {
    highlightBrandText();
  });

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initOrDestroyPageTransitions();
      unwrapDropdownMenu();
      moveDownloadBtn();
      setVideoDimensions();
    }, 250);
  });
});
